import { RouterProvider, createHashRouter } from 'react-router-dom';
import './App.scss';
import Layout from './components/Layout';
import AdminLayout from './pages/Adminpages/AdminLayout.jsx';
import { lazy, Suspense, useContext, useEffect, useState } from 'react';
import Loading from './components/Loading/Loading';
import LoginProtector from './Protectors/LoginProtector.jsx';
import ChangeProtector from './Protectors/ChangeProtector.jsx';
import { LocationContext } from './Context/UserLocation.jsx';
import { BaseUrl } from './API/Url.js';
import axios from 'axios';
import { getDecodedToken } from './helpers/TokenDecode.jsx';
import { useCookies } from 'react-cookie';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { reactLocalStorage } from 'reactjs-localstorage';
import AdminProtector from './Protectors/AdminProtector.jsx';
import { jwtDecode } from 'jwt-decode';
import { Helmet } from 'react-helmet';



const Login = lazy(() => import("./pages/Auth/login/login"));
const Notfound = lazy(() => import("./pages/Notfound/Notfound.jsx"));
const SignUp = lazy(() => import("./pages/Auth/SignUp/SignUp"));
const ForgetPassword = lazy(() => import('./pages/Auth/ForgetPassword/ForgetPassword'));
const Home = lazy(() => import("./pages/Home/Home"));
const Blogs = lazy(() => import("./pages/Blog/Blog"));
const Products = lazy(() => import("./pages/products/products"));
const Details = lazy(() => import("./pages/products_Details/Details"));
const AboutUs = lazy(() => import("./pages/AboutUs/Aboutus"));
const Faq = lazy(() => import("./pages/FAQ/Faq.jsx"));
const Catalog = lazy(() => import("./pages/Catalog/Catalog.jsx"));
const Bundels = lazy(() => import("./pages/Bundels/Bundels.jsx"));
const Bundelsdetails = lazy(() => import("./pages/BundelsDetails/Bundeldetails.jsx"));
const Contact = lazy(() => import("./pages/Contact/Contact.jsx"));
const Cart = lazy(() => import("./pages/Cart/Cart.jsx"));
const Fav = lazy(() => import("./pages/Favourit/Fav.jsx"));
const Profile = lazy(() => import("./pages/Profile/Profile.jsx"));
const BlogDetails = lazy(() => import("./pages/Blogdetails/BlogDetails.jsx"));
const UserOrder = lazy(() => import('./pages/Order/Order.jsx'));
const FaQ = lazy(() => import('./pages/FAQ/Faq.jsx'));
const Policy = lazy(() => import('./pages/Policy/Policy.jsx'));
const Refund = lazy(() => import("./pages/Refund/Refund.jsx"))


/////////////////////////// admin routes ////////

const OdrerDetails = lazy(() => import("./pages/Adminpages/Orders/OdrerDetails.jsx"));
const Orders = lazy(() => import('./pages/Adminpages/Orders/Orders'));
const Guestorders = lazy(() => import('./pages/Adminpages/guestorders/Guestorders.jsx'));
const Orderbill = lazy(() => import('./pages/Adminpages/Orderbill/Orderbill.jsx'));
const Guestorderbill = lazy(() => import('./pages/Adminpages/Guestorderbill/Guestorderbill.jsx'));

const Categoery = lazy(() => import('./pages/Adminpages/Categoery/Create/Categoery.jsx'));
const GetAllCategoeries = lazy(() => import('./pages/Adminpages/Categoery/Get All/GetAllCats.jsx'));
const UpdateCat = lazy(() => import('./pages/Adminpages/Categoery/Update/UpdateCat.jsx'));
const ChangeCatImage = lazy(() => import('./pages/Adminpages/Categoery/ChangeImage/ChangeCatImage.jsx'));
const ChangeCatText = lazy(() => import("./pages/Adminpages/Categoery/ChangeText/ChangeCatText.jsx"))


const Coupon = lazy(() => import('./pages/Adminpages/Coupon/CreateCoupon/Coupon.jsx'));
const GetAllCopons = lazy(() => import("./pages/Adminpages/Coupon/AllCoupons/AllCoupons.jsx"));
const UpdateCoupon = lazy(() => import("./pages/Adminpages/Coupon/UpdateCoupon/UpdateCoupon.jsx"));

const ProductsAdmin = lazy(() => import('./pages/Adminpages/Products/All Products/ProductsAdmin.jsx'));
const CreateProduct = lazy(() => import("./pages/Adminpages/Products/Create Product/CreateProduct.jsx"));
const ChangeProductText = lazy(() => import("./pages/Adminpages/Products/Change Text/ChangeProductText.jsx"));
const ChangeProductImage = lazy(() => import("./pages/Adminpages/Products/Update image/ChnageProductImage.jsx"));
const Reviews = lazy(() => import('./pages/Adminpages/Products/All Reviews/Reviews.jsx'));
const Lowstock = lazy(() => import('./pages/Adminpages/Products/LowStock/Lowstock.jsx'));


const Bundles = lazy(() => import('./pages/Adminpages/Bundles/Bundles'));

const Usersemails = lazy(() => import('./pages/Adminpages/UsersEmails/Usersemails'));
const UsersAdmin = lazy(() => import('./pages/Adminpages/Usres/UsersAdmin'));
const ChangePassword = lazy(() => import("./pages/Auth/ChangePassword/ChangePassword.jsx"));

const CreateBlog = lazy(() => import("./pages/Adminpages/Blogs/CreateBlogs/CreateBlogs.jsx"));
const UpdateBlogs = lazy(() => import("./pages/Adminpages/Blogs/UpdateBlogs/UpdateBlogs.jsx"));
const DeleteBlogs = lazy(() => import("./pages/Adminpages/Blogs/DeleteBlogs/DeleteBlogs.jsx"));
const SelectedBlog = lazy(() => import("./pages/Adminpages/Blogs/SelectedBlog/SelectedBlog.jsx"));
const ChangeBlogImage = lazy(() => import("./pages/Adminpages/Blogs/ChangeImage/ChangeImage.jsx"));

const DeleteBundle = lazy(() => import('./pages/Adminpages/Bundles/DeleteBundle.jsx'));



function App() {
  <Helmet>
    <meta charSet="utf-8" />
    <title>| MeMa Hijab</title>
    <link rel="canonical" href="https://memahijab.com/#/Contact" />
    <meta property="og:url" content="https://memahijab.com/#/Contact" />
    <meta property="og:title" content="product Details | MeMa Hijab" />
    <meta property="og:description" content="product Details for mema products" />
    <meta name="keywords" content="MeMa Hijab, product details, hijabs, fashion, style, Muslim fashion, modest wear" />
    <script type="application/ld+json">
      {`
      {
          "@context": "https://schema.org",
          "@type": "Store",
          "name": "MeMa Store",
          "description": "Your one-stop destination for premium hijab clothes, offering a wide range of styles, colors, and fabrics tailored for modern women.",
          "url": "https://memahijab.com/",
          "logo": "https://memahijab.com/logo192.png",
          "sameAs": [
              "https://www.facebook.com/share/5MtSyMqW9kanUmck/?mibextid=LQQJ4d",
              "https://www.instagram.com/mema.hijabi?igsh=Mm1iazlhODhzNGZq&utm_source=qr",
              "https://www.snapchat.com/add/mema.hijabi?invite_id=vZM9Qjzw&locale=en_SA%40calendar%3Dgregorian&share_id=sZ5acuwIREmB2kb4xwgM7w&xp_id=1&sid=4c3eb7a9bcfc4ae480fcfc6bffe0a4f0",
              "https://wa.me/+201021205001?",
              "https://www.tiktok.com/@mema.hijabi?_t=8piQyUowLbj&_r=1"
          ]
      }
      `}
    </script>
  </Helmet>

  const { setLocation, setUserCart, setRole } = useContext(LocationContext);
  const [Cookies, , removeCookie] = useCookies(['token'])
  const UserData = Cookies.token && getDecodedToken(Cookies.token);
  const [UserVer, setUserVer] = useState(true);

  const { i18n } = useTranslation();

  const LogOut = () => {
    removeCookie('token');
  }

  const CheckForUserToken = async () => {
    await axios.post(`${BaseUrl}/auth/CheckUser`, {}, {
      headers: {
        token: Cookies.token && Cookies.token
      }
    }).then((res) => {
      setUserVer(res.data.status);
      if (res.data.status)
        setRole(jwtDecode(Cookies.token).role)
    })
      .catch((err) => console.log(err));

  }

  const MainLanguage = reactLocalStorage.get("lan");

  useEffect(() => {
    if (MainLanguage) {
      i18n.changeLanguage(MainLanguage.toLowerCase());
    } else {
      reactLocalStorage.set("lan", "en")
      i18n.changeLanguage(MainLanguage?.toLowerCase());
    }
  }, []);


  async function getIPLocation() {
    try {
      const apiKey = "c7dda64bd1aa48e1ac1fe5a3529eb3f0";  // Your ipgeolocation.io API key
      const response = await fetch(`https://api.ipgeolocation.io/ipgeo?apiKey=${apiKey}`);

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const data = await response.json();
      const country = data?.country_name || "Country not found";
      setLocation(country === "Country not found" ? "Saudi Arabia" : country);

    } catch (error) {
      console.error("IP-based location request failed:", error);
      setLocation("Country not found");
    }
  }


  useEffect(() => {
    getIPLocation();
  }, []);


  const CheckCart = async () => {

    if (!Cookies.token) return;

    const response = await axios.get(`${BaseUrl}/Cart/CartCheck/${UserData.id}`, {
      headers: {
        token: Cookies.token && Cookies.token
      }
    });
    return response.data?.CartLength
  }

  const { data: CartCheck } = useQuery("Check Cart Length", CheckCart)


  useEffect(() => {
    setUserCart(CartCheck)
  }, [setUserCart, CartCheck])

  useEffect(() => {

    if (Cookies.token) {
      CheckForUserToken();
    }
    if (!UserVer)
      LogOut();


  }, [Cookies.token])





  const routes = createHashRouter([
    {
      path: "", element: <Layout />, children: [

        {
          index: true, element: <Suspense fallback={<Loading />}>
            <Home />
          </Suspense>
        },
        {
          path: "Login", element: <Suspense fallback={<Loading />}>
            <Login />
          </Suspense>
        },
        {
          path: "SignUp", element: <Suspense fallback={<Loading />}>
            <SignUp />
          </Suspense>
        },
        {
          path: "Forget", element: <Suspense fallback={<Loading />}>
            <ForgetPassword />
          </Suspense>
        },
        {
          path: "Blog", element: <Suspense fallback={<Loading />}>
            <Blogs />
          </Suspense>
        },
        {
          path: "Blogdetails/:blodetailsid", element: <Suspense fallback={<Loading />}>
            <BlogDetails />
          </Suspense>
        },
        {
          path: "productsdetails/:id", element: <Suspense fallback={<Loading />}>
            <Details />
          </Suspense>
        },
        {
          path: "Contact", element: <Suspense fallback={<Loading />}>
            <Contact />
          </Suspense>
        },
        {
          path: "Cart", element: <Suspense fallback={<Loading />}>
            <Cart />
          </Suspense>
        },
        {
          path: "Favourits", element: <Suspense fallback={<Loading />}>
            <Fav />
          </Suspense>
        },
        {
          path: "Aboutus", element: <Suspense fallback={<Loading />}>
            <AboutUs />
          </Suspense>
        },
        {
          path: "FAQ", element: <Suspense fallback={<Loading />}>
            <Faq />
          </Suspense>
        },
        {
          path: "catalog", element: <Suspense fallback={<Loading />}>
            <Catalog />
          </Suspense>
        },
        {
          path: "catalog/:categoery", element: <Suspense fallback={<Loading />}>
            <Products />
          </Suspense>
        },
        {
          path: "bundels", element: <Suspense fallback={<Loading />}>
            <Bundels />
          </Suspense>
        },
        {
          path: "bundel/:id", element: <Suspense fallback={<Loading />}>
            <Bundelsdetails />
          </Suspense>
        },
        {
          path: "Profile", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <Profile />
            </LoginProtector>
          </Suspense>
        }
        ,
        {
          path: "ChangePassword/:UserId", element: <Suspense fallback={<Loading />}>
            <ChangeProtector>
              <ChangePassword />
            </ChangeProtector>
          </Suspense>
        }, {
          path: 'UserOrder', element: <Suspense fallback={<Loading />}>
            <UserOrder />
          </Suspense>
        },
        {
          path: "FaQ", element: <Suspense fallback={<Loading />}>
            <FaQ />
          </Suspense>
        },
        {
          path: "Policy", element: <Suspense fallback={<Loading />}>
            <Policy />
          </Suspense>
        },
        {
          path: "Refund", element: <Suspense fallback={<Loading />}>
            <Refund />
          </Suspense>
        }
        , {
          path: '*', element: <Suspense fallback={<Loading />}>
            {< Notfound />}
          </Suspense>
        }
      ],
    },





    {
      path: "DashboardMema", element: <AdminLayout />, children: [

        {
          index: true, element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <Orders />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "GuestOrders", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <Guestorders />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "AddCategoery", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <Categoery />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "AllCategories", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <GetAllCategoeries />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "UpdateCategories", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <UpdateCat />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "ChangeText/:id", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <ChangeCatText />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "ChangeCategoryImage/:id", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <ChangeCatImage />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "ProductsAdmin", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <ProductsAdmin />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "CreateProduct", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <CreateProduct />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "ChangeProductText/:id", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <ChangeProductText />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "Reviews", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <Reviews />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "Lowstock", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <Lowstock />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "ChangeImage/:id", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <ChangeProductImage />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "AddCoupon", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <Coupon />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        }
        ,
        {
          path: "AllCoupons", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <GetAllCopons />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        }
        ,
        {
          path: "UpdateCoupon/:id", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <UpdateCoupon />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "ABundles", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <Bundles />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "deleteBundles", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <DeleteBundle />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "AUsersemails", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <Usersemails />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "AUsersAdmin", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <UsersAdmin />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "BlogCreate", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <CreateBlog />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "BlogUpdate", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <UpdateBlogs />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "BlogUpdate/:id", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <SelectedBlog />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "BlogUpdateImage/:id", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <ChangeBlogImage />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "DeleteBlogs", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <DeleteBlogs />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "odrerdetails/:orderid", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <OdrerDetails />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "Orderbill/:orderid", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <Orderbill />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "GuestOrderbill/:guestorderid", element: <Suspense fallback={<Loading />}>
            <LoginProtector>
              <AdminProtector>
                <Guestorderbill />
              </AdminProtector>
            </LoginProtector>
          </Suspense>
        },
        {
          path: "*", element: <Suspense fallback={<Loading />}>
            {<Notfound />}
          </Suspense>
        }
      ]
    }
  ])

  return (
    <RouterProvider router={routes}></RouterProvider>
  );
}

export default App;
